import { Route, Routes } from "react-router-dom";
import Step1 from "./login/Step1";
import Step2 from "./phone/Step2";

const Login = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Step1 />} />
        <Route path="verifyPhone" element={<Step2 />} />
      </Routes>
    </>
  );
};

export default Login;
